import _ from 'underscore';
import search from 'utils/ReportingWebAPIUtils';
import AdminServerActionCreators from 'actions/AdminServerActionCreators';
import { getFrequentShippersRequest, getGrowthReportRequest, getDailyReportGrowthRequest, getDailyReportCustomerRequest, getDailyReportLookbackRequest, receiveFrequentShippers, receiveGrowthMetrics, receiveDailyReportGrowthMetrics, receiveDailyReportCustomerMetrics, receiveDailyReportLookbackMetrics } from 'utils/elasticsearch/service';
const handleError = (err) => {
    console.log('the ES error: ', err);
};
export function getFrequentShippers(date) {
    const request = getFrequentShippersRequest(date);
    search(request).then((res) => {
        console.log("RES", res);
        AdminServerActionCreators.receiveFrequentShippers({
            frequentShippers: receiveFrequentShippers(date, res.aggregations)
        });
    }, handleError);
}
;
export function getGrowthMetrics(date, query) {
    const request = getGrowthReportRequest(date, query);
    search(request).then((res) => {
        console.log("RES", res);
        AdminServerActionCreators.receiveGrowthMetrics({
            market: _.first(_.keys(query.market)),
            metrics: receiveGrowthMetrics(date, res.aggregations)
        });
    }, handleError);
}
;
export function getDailyGrowthMetrics(date, query) {
    const request = getDailyReportGrowthRequest(date, query);
    search(request).then((res) => {
        AdminServerActionCreators.receiveDailyGrowthMetrics({
            metrics: receiveDailyReportGrowthMetrics(date, res.aggregations)
        });
    }, handleError);
}
;
export function getDailyCustomerMetrics(date, query) {
    const request = getDailyReportCustomerRequest(date, query);
    search(request).then((res) => {
        AdminServerActionCreators.receiveDailyCustomerMetrics({
            metrics: receiveDailyReportCustomerMetrics(date, res.aggregations)
        });
    }, handleError);
}
;
export function getDailyLookbackMetrics(date, query) {
    const request = getDailyReportLookbackRequest(date, query);
    search(request).then((res) => {
        AdminServerActionCreators.receiveDailyLookbackMetrics({
            metrics: receiveDailyReportLookbackMetrics(date, res.aggregations),
            date
        });
    }, handleError);
}
;
